/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description ViewPlanFeatures Button
 */
import { Button, Modal } from 'antd';

import { ActivePlanCard, AddOnFeaturesCard, CLASS_NAMES } from 'components/subscriptions/settings/PlanCard';

/**
 * ViewPlanFeatures
 *
 */
const ViewPlanFeatures: React.FC<{ plan?: Subscriptions.IActivePlanModel; addOn?: Subscriptions.IAddOnResponseModel }> = ({
	plan,
	addOn,
}) => {
	const getModalContent = () => {
		if (addOn) {
			return <AddOnFeaturesCard addOn={addOn} />;
		}
		if (plan) {
			return <ActivePlanCard plan={plan} />;
		}
	};

	const showPlanFeaturesModal = () => {
		Modal.info({
			icon: null,
			maskClosable: true,
			content: getModalContent(),
			closable: true,
			footer: null,
			className: CLASS_NAMES.activePlanCardModal,
		});
	};

	return (
		<Button type='default' onClick={showPlanFeaturesModal}>
			{'View Features'}
		</Button>
	);
};

export default ViewPlanFeatures;
